export default __webpack_public_path__ + "static/media/bg.2363c20a.jpg";